import LegacyApiHelper from '../classes/legacy-api-helper';

const api = new LegacyApiHelper('opportunity activity');

export const getActivitiesByJobId = async jobId => {
  const response = await api.GET(`/opportunities/${jobId}/events`);
  return { data: response.data };
};
